import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServiceCards } from '../components/ServiceCards';
import { NewsAlerts } from '../components/NewsAlerts';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-487">
      <Header data-id="element-488" />
      <main className="flex-grow" data-id="element-489">
        <HeroSection data-id="element-490" />
        <ServiceCards data-id="element-491" />
        <NewsAlerts data-id="element-492" />
      </main>
      <Footer data-id="element-493" />
    </div>;
}